module.exports = __webpack_public_path__ + "img/actived_icon.cadd3592.png";